import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { CommunicationConfigService, ConfigService } from '@argalis-apps/angular-global';
import { of, Observable } from 'rxjs';

const TESTDATA_PARAMS = {
  params: {
    listTypeClients: [
      {
        id: 1,
        libelle: 'entreprise de test'
      },
      {
        id: 2,
        libelle: 'another kind of test company'
      }
    ],
    listEcomParams: [
      {
        code: 'HTML_CREATION_CLIENT',
        value:
          'DISCLAIMER RGPD, Crebriores animi quorum et turbela maerens protector domesticus populari quo quae praeteritis prohibebant animi domesticus torrentes Hermogenis egerat protector potuit.'
      }
    ]
  }
};
const TESTDATA_SIGNUP_KO_P = 'matchName';
const TESTDATA_SIGNUP_KO_E = 'matchEntreprise'; // 'matchMail' || 'matchName' || 'matchClientAll'
// 'matchEntreprise' || 'matchEntrepriseAll'

interface IParamsEco {
  params: {
    listTypeClients: { id: number; libelle: string }[];
    listEcomParams: { code: string; value: string }[];
  };
}

@Injectable({
  providedIn: 'root'
})
export class InscriptionService {
  constructor(
    private communicationConfigService: CommunicationConfigService,
    private http: HttpClient,
    private configService: ConfigService
  ) {}

  getEcomParams(): Observable<IParamsEco> {
    if (this.configService.getOptions().useTestData === true) {
      return of(TESTDATA_PARAMS);
    } else {
      let params = new HttpParams();
      params = params.set('isSigningUp', 'true');
      return this.http.get<IParamsEco>(
        `${this.communicationConfigService.getApiUri()}/site-ecommerce-params/list/myparams`,
        { params }
      );
    }
  }

  signUpParticulier(data) {
    if (this.configService.getOptions().useTestData === true) {
      return of(TESTDATA_SIGNUP_KO_P);
    } else {
      return this.http.post(`${this.communicationConfigService.getApiUri()}/sign/upEcomParticulier`, data);
    }
  }

  signUpEntreprise(data) {
    if (this.configService.getOptions().useTestData === true) {
      return of(TESTDATA_SIGNUP_KO_E);
    } else {
      return this.http.post(`${this.communicationConfigService.getApiUri()}/sign/upEcomEntreprise`, data);
    }
  }
}
